// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MenuItem":"bha_a bih_vt bih_ea bih_a","MenuItem__Btn":"bha_b bih_z","MenuItem__subtitle":"bha_c"};